// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_navbarLayout__3jPEY {
  list-style: none;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0.5rem;
  position: fixed;
  bottom: 0;
  box-sizing: border-box;
  height: var(--nav-height);
  background: var(--color-nav-bg);
  box-shadow: 0 -2px 16px rgba(0, 0, 0, 0.18);
  z-index: 100;
  /* Safe area para iPhone */
  padding-bottom: env(safe-area-inset-bottom, 0);
}
.style_navbarLayout__3jPEY.style_navbarLayoutDiseable__huKBu {
  display: none;
}
.style_navbarLayout-list__MtCYa {
  list-style: none;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: relative;
}
.style_navbarLayout-list__MtCYa .style_item__Phr9r {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 1;
}
.style_navbarLayout-list__MtCYa .style_item__Phr9r .style_link__hLu0J {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3px;
  width: 56px;
  height: 52px;
  border-radius: 12px;
  color: var(--color-nav-icon);
  text-decoration: none;
  transition: color 0.15s ease;
}
.style_navbarLayout-list__MtCYa .style_item__Phr9r .style_link__hLu0J .style_icon__QXeuW {
  font-size: 22px;
  line-height: 1;
  transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.style_navbarLayout-list__MtCYa .style_item__Phr9r .style_link__hLu0J .style_label__5Jorf {
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.02em;
  opacity: 0.7;
  transition: opacity 0.15s ease;
}
.style_navbarLayout__3jPEY .style_itemActive__YIInU .style_link__hLu0J {
  background: rgba(255, 255, 255, 0.15);
  color: var(--color-nav-text-active);
}
.style_navbarLayout__3jPEY .style_itemActive__YIInU .style_link__hLu0J .style_icon__QXeuW {
  transform: scale(1.12);
}
.style_navbarLayout__3jPEY .style_itemActive__YIInU .style_link__hLu0J .style_label__5Jorf {
  opacity: 1;
}

.style_notify__bUtKu {
  position: relative;
}
.style_notify__bUtKu .style_count__NVGVn {
  position: absolute;
  top: 4px;
  right: 6px;
  background: var(--color-accent);
  min-width: 16px;
  height: 16px;
  border-radius: 8px;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 3px;
  border: 2px solid var(--color-nav-bg);
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/templates/partials/NavBar/style.module.scss"],"names":[],"mappings":"AAAA;EAKI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,SAAA;EACA,sBAAA;EAKA,yBAAA;EACA,+BAAA;EACA,2CAAA;EACA,YAAA;EAEA,0BAAA;EACA,8CAAA;AARJ;AAfI;EACI,aAAA;AAiBR;AAOI;EACI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;AALR;AAOQ;EACI,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AALZ;AAOY;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;EACA,qBAAA;EACA,4BAAA;AALhB;AAOgB;EACI,eAAA;EACA,cAAA;EACA,4DAAA;AALpB;AAQgB;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;AANpB;AAcQ;EAGI,qCAAA;EACA,mCAAA;AAdZ;AAgBY;EACI,sBAAA;AAdhB;AAiBY;EACI,UAAA;AAfhB;;AAqBA;EACI,kBAAA;AAlBJ;AAoBI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,+BAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,qCAAA;EACA,UAAA;AAlBR","sourcesContent":[".navbarLayout {\n    &.navbarLayoutDiseable {\n        display: none;\n    }\n\n    list-style: none;\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 0 0.5rem;\n    position: fixed;\n    bottom: 0;\n    box-sizing: border-box;\n    // Reserva el safe-area (home indicator) DENTRO de la altura de la barra, así los\n    // íconos quedan centrados en el alto visible y no empujados hacia arriba.\n    // Altura responsiva (10vh) + safe-area. Definida en --nav-height (colors.scss)\n    // para mantenerla sincronizada con el clearance del contenido y el panel del mapa.\n    height: var(--nav-height);\n    background: var(--color-nav-bg);\n    box-shadow: 0 -2px 16px rgba(0,0,0,0.18);\n    z-index: 100;\n\n    /* Safe area para iPhone */\n    padding-bottom: env(safe-area-inset-bottom, 0);\n\n    &-list {\n        list-style: none;\n        width: 100%;\n        display: flex;\n        justify-content: space-around;\n        align-items: center;\n        position: relative;\n\n        .item {\n            flex: 1;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            position: relative;\n            z-index: 1;\n\n            .link {\n                display: flex;\n                flex-direction: column;\n                justify-content: center;\n                align-items: center;\n                gap: 3px;\n                width: 56px;\n                height: 52px;\n                border-radius: 12px;\n                color: var(--color-nav-icon);\n                text-decoration: none;\n                transition: color 0.15s ease;\n\n                .icon {\n                    font-size: 22px;\n                    line-height: 1;\n                    transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);\n                }\n\n                .label {\n                    font-size: 10px;\n                    font-weight: 500;\n                    letter-spacing: 0.02em;\n                    opacity: 0.7;\n                    transition: opacity 0.15s ease;\n                }\n            }\n        }\n\n    }\n\n    .itemActive {\n        .link {\n            // El highlight va DIRECTO sobre el link activo (no un indicador flotante\n            // calculado en JS), así queda siempre alineado con el ícono.\n            background: rgba(255,255,255,0.15);\n            color: var(--color-nav-text-active);\n\n            .icon {\n                transform: scale(1.12);\n            }\n\n            .label {\n                opacity: 1;\n            }\n        }\n    }\n}\n\n.notify {\n    position: relative;\n\n    .count {\n        position: absolute;\n        top: 4px;\n        right: 6px;\n        background: var(--color-accent);\n        min-width: 16px;\n        height: 16px;\n        border-radius: 8px;\n        color: #fff;\n        font-size: 10px;\n        font-weight: 700;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding: 0 3px;\n        border: 2px solid var(--color-nav-bg);\n        z-index: 2;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navbarLayout": `style_navbarLayout__3jPEY`,
	"navbarLayoutDiseable": `style_navbarLayoutDiseable__huKBu`,
	"navbarLayout-list": `style_navbarLayout-list__MtCYa`,
	"item": `style_item__Phr9r`,
	"link": `style_link__hLu0J`,
	"icon": `style_icon__QXeuW`,
	"label": `style_label__5Jorf`,
	"itemActive": `style_itemActive__YIInU`,
	"notify": `style_notify__bUtKu`,
	"count": `style_count__NVGVn`
};
export default ___CSS_LOADER_EXPORT___;
